import { PropsWithChildren, useState } from 'react'

import { CallStatus, CallStatusContext } from './CallStatusContext'

export function CallStatusProvider({ children }: PropsWithChildren) {
  const [status, setStatus] = useState<CallStatus>('loading')

  return (
    <CallStatusContext.Provider value={{ status, setStatus }}>
      {children}
    </CallStatusContext.Provider>
  )
}
